import React from 'react';
import { MdOutlineWarningAmber } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';

const ExpiredAlert = ({ isOpen, onClose, message }) => {
  const navigate = useNavigate();

  if (!isOpen) return null;

  const handleRedirect = () => {
    onClose?.();
    navigate('/billing'); // update path if needed
  };

  const displayMessage = message || 'Your subscription plan has expired. To continue using all features without interruption, please purchase or renew your plan.';

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
      <div className="bg-white dark:bg-gray-900 rounded-2xl shadow-2xl w-full max-w-md p-6 animate-fadeIn">
        <div className="flex items-center gap-4 mb-4">
          <div className="bg-yellow-100 p-3 rounded-full">
            <MdOutlineWarningAmber className="text-amber-400 text-3xl" />
          </div>
          <h2 className="text-xl font-semibold text-gray-800 dark:text-white">Your Plan Has Expired</h2>
        </div>

        <p className="text-gray-600 dark:text-gray-300 mb-6 leading-relaxed">
          {displayMessage}
        </p>

        <div className="flex justify-end gap-3">
          <button
            onClick={onClose}
            className="px-4 py-2 text-sm rounded-md border border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800 transition"
          >
            Cancel
          </button>
          <button
            onClick={handleRedirect}
            className="px-4 py-2 text-sm rounded-md bg-primary-black text-white hover:bg-primary-black/80 transition focus:outline-none focus:ring-2 focus:ring-blue-400"
          >
            Purchase Now
          </button>
        </div>
      </div>
    </div>
  );
};

export default ExpiredAlert;
